import React, {useState} from 'react';
import Paper from "@mui/material/Paper";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import styled from "styled-components";
import {colors} from "../../maps/colors";
import useZibi from "../../zibi/UseZibi";
import SensorStatus from "../SensorStatus";
import IconBtn from "../IconBtn";
import SensorTestDialog from "../testSensor/SensorTestDialog";
import SensorWeightDialog from "../dialogs/SensorWeightDialog";
import {api} from "../../maps/data.js";
import {_} from "../../domain/languageSlice";
import {sensorsI18nTypeMap} from "../../maps/sensorsI18nTypeMap";

const WrapperStyled = styled.div`
    padding: 10px;
    position: relative;
`;

const ItemStyled = styled.div`

`;

const TitleStyled = styled.h3`
    font-size: 18px;
    font-weight: 500;
    margin: 0;
`;

const ContentStyled = styled.span`
    font-size: 12px;
`;

const TestSensorStyled = styled.div`
    position: absolute;
    right: 5px;
    bottom: 5px;
`;

const LabelStyled = styled.span`
    font-size: 11px;
    color: ${colors.BLACK_LIGHT};
    font-weight: 300;
`;

const TypeStyled = styled.span`
    font-size: 11px;
    color: ${colors.BLACK_LIGHT};
    font-weight: 300;
    position: absolute;
    right: 15px;
    top: 0;
`;

const AutoUpdateStyled = styled.span`
    font-weight: 300;
    font-size: 11px;
    position: absolute;
    right: -12px;
    top: 12px;

    .MuiFormControlLabel-label {
        font-size: 11px;
    }
`;

const SensorItem = ({sensor, testSensorHandle, sensorToTest, sensorToWeight, weightSensorHandle}) => {
    const [sensorStatuses] = useZibi('sensorStatuses');
    const [sensors, set_sensors] = useZibi('sensors');

    const isDialogOpened = sensorToTest === sensor?._id;
    const isWeightOpened = sensorToWeight === sensor?._id;

    const [testSensorDialogSensor, s_testSensorDialogSensor] = useState(isDialogOpened ? sensor : "");
    const [seeWeightGraph, s_seeWeightGraph] = useState(isWeightOpened ? sensor : "");

    const handleAutoUpdate = async () => {
        const editedSensor = await api({
            type: "editSensor",
            data: {autoUpdate: !sensor.autoUpdate, sensorId: sensor._id}
        });
        const temp = {...sensors};
        temp[editedSensor._id] = {...editedSensor, translatedType: _(sensorsI18nTypeMap[editedSensor.type])};
        set_sensors(temp);
    };

    const handleIgnoreConfig = async () => {
        const editedSensor = await api({
            type: "editSensor",
            data: {ignoreUpdate: !sensor.ignoreUpdate, sensorId: sensor._id}
        });
        const temp = {...sensors};
        temp[editedSensor._id] = {...editedSensor, translatedType: _(sensorsI18nTypeMap[editedSensor.type])};
        set_sensors(temp);
    };

    const sensorStatusData = sensorStatuses[sensor._id];
    const status = sensorStatusData?.status;
    const statusUpdateAt = sensorStatusData?.statusUpdateAt;
    const siteId = Array.isArray(sensor?.siteId) ? sensor.siteId[0] : sensor.siteId;
    const edgeId = Array.isArray(sensor?.edgeId) ? sensor.edgeId[0] : sensor.edgeId;
    const type = sensor.type;

    return (<Paper elevation={3}>
        <WrapperStyled>
            <SensorStatus
                size={7}
                status={status}
                statusUpdateAt={statusUpdateAt}
            />
            <AutoUpdateStyled>
                <FormGroup>
                    <FormControlLabel control={<Switch
                        size="small"
                        checked={sensor.autoUpdate}
                        onChange={handleAutoUpdate}
                    />}
                                      label="Auto update"
                    />
                    <FormControlLabel control={<Switch
                        size="small"
                        checked={sensor.ignoreUpdate}
                        onChange={handleIgnoreConfig}
                    />}
                                      label="Ignore config"
                    />
                </FormGroup>
            </AutoUpdateStyled>
            <TypeStyled>
                {sensor.translatedType}
            </TypeStyled>
            <ItemStyled>
                <TitleStyled>
                    <LabelStyled>Board Id:</LabelStyled> {sensor.boardId}
                </TitleStyled>
            </ItemStyled>
            <ItemStyled>
                <ContentStyled>
                    <LabelStyled>MAC:</LabelStyled> {sensor.mac}
                </ContentStyled>
            </ItemStyled>
            {sensor.ip && (
                <ItemStyled>
                    <ContentStyled>
                        <LabelStyled>IP:</LabelStyled> {sensor.ip}
                    </ContentStyled>
                </ItemStyled>
            )}
            <ItemStyled>
                <ContentStyled>
                    <LabelStyled>Sensor Id:</LabelStyled> {sensor._id}
                </ContentStyled>
            </ItemStyled>
            <ItemStyled>
                <ContentStyled>
                    <LabelStyled>Model:</LabelStyled> {sensor.model}
                </ContentStyled>
            </ItemStyled>
            <ItemStyled>
                <ContentStyled>
                    <LabelStyled>Version:</LabelStyled> {sensor.version}
                </ContentStyled>
            </ItemStyled>
            <ItemStyled>
                <ContentStyled>
                    <LabelStyled>Installer:</LabelStyled> {sensor.installerName}
                </ContentStyled>
            </ItemStyled>
            <ItemStyled>
                <ContentStyled>
                    <LabelStyled>Distributor:</LabelStyled> {sensor.distributorName}
                </ContentStyled>
            </ItemStyled>
            <TestSensorStyled>
                <IconBtn size="small"
                         onClick={() => {
                             s_testSensorDialogSensor(sensor);
                             testSensorHandle(sensor._id);
                         }}>scienceIcon</IconBtn>
            </TestSensorStyled>
            {type === 3 && (<TestSensorStyled
                style={{right: 45}}
            >
                <IconBtn size="small"
                         onClick={() => {
                             s_seeWeightGraph(sensor);
                             weightSensorHandle(sensor._id);
                         }}>scaleIcon</IconBtn>
            </TestSensorStyled>)}
        </WrapperStyled>
        {testSensorDialogSensor && (<SensorTestDialog
            edgeId={edgeId}
            siteId={siteId}
            sensor={{sensor: testSensorDialogSensor, sensorId: sensor._id}}
            onClose={() => {
                s_testSensorDialogSensor("");
                testSensorHandle(null);
            }}
        />)}
        {seeWeightGraph && (<SensorWeightDialog
            edgeId={edgeId}
            siteId={siteId}
            sensor={{sensor: seeWeightGraph, sensorId: sensor._id}}
            onClose={() => {
                s_seeWeightGraph("");
                weightSensorHandle(null);
            }}
        />)}
    </Paper>);
};

export default SensorItem;